import { controls,grouped } from "../controls";
const bank_cbs_settings = {
label: "Bank Cbs Settings",
pageLabel: "Bank Cbs Settings",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
]
,form:[
...controls.checkBox({ tab: "general", label: "Allow Direct Loans",default:false, name: "allow_direct_loans" }),
...controls.checkBox({ tab: "general", label: "Same Day Begin In The Branch",default:false, name: "same_day_begin_in_the_branch" }),
]
,history:{
perPage: 10,
reportHeader: "Bank Cbs Settings",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Allow Direct Loans",accessor: "allow_direct_loans",type:'tick'},
{Header: "Same Day Begin In The Branch",accessor: "same_day_begin_in_the_branch",type:'tick'},
{Header: "Gl",accessor: "BankCBSSetting-bank_cash_hand_gl-gl_display",},
]}};
export default bank_cbs_settings;